export const parseFscSeatStepperValue = (rawValue, min, max) => {
  if (rawValue === '') {
    return undefined;
  }
  const value = Number(rawValue);
  if (!Number.isFinite(value) || !Number.isInteger(value) || value < min) {
    return undefined;
  }
  if (max !== undefined && value > max) {
    return undefined;
  }
  return value;
};